export default {
  radius: '70%',
  activeRadius: '75%',
  lineWidth: 10,
  digitalFlopToFixed: 2,
  // color: ['#0011FF', '#0059FF', '#00C8FF', '#00FFDD', '#1DC46B', '#0C803A', '#FAFAFA', '#1954C2', '#339DDE', '#3AB898'],
  color: ['#0011FF', '#0059FF', '#13909b', '#ffff00', '#1DC46B', '#0C803A', '#FAFAFA', '#1954C2', '#339DDE', '#3AB898'],
  data: [
    { name: '电商平台', value: 3200 },
    { name: '南阳', value: 820 },
    { name: '西峡', value: 764 },
    { name: '驻马店', value: 666 },
    { name: '新乡', value: 548 },
    { name: '测试', value: 548 },
    { name: '安全', value: 548 },
    { name: '信息', value: 548 },
    { name: '信息', value: 548 },
    { name: '信息', value: 548 }
  ]
}